/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import MedicationOrdersMedicationOrder from './MedicationOrdersMedicationOrder';

/**
 * The MedicationOrdersBody model module.
 * @module model/MedicationOrdersBody
 * @version v0.3
 */
export default class MedicationOrdersBody {
  /**
   * Constructs a new <code>MedicationOrdersBody</code>.
   * @alias module:model/MedicationOrdersBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MedicationOrdersBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MedicationOrdersBody} obj Optional instance to populate.
   * @return {module:model/MedicationOrdersBody} The populated <code>MedicationOrdersBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MedicationOrdersBody();
      if (data.hasOwnProperty('medication_order'))
        obj.medicationOrder = MedicationOrdersMedicationOrder.constructFromObject(data['medication_order']);
    }
    return obj;
  }
}

/**
 * @member {module:model/MedicationOrdersMedicationOrder} medicationOrder
 */
MedicationOrdersBody.prototype.medicationOrder = undefined;

